<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BQocvK/tc-custom/9781442488038.jpg?1713387613881" alt="This image is the cover for the book Brighty of the Grand Canyon, Marguerite Henry Horseshoe Library"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brighty of the Grand Canyon, Marguerite Henry Horseshoe Library
      </h1>
      <p class="bookDescription body article font2">
        <b>A determined little burro earns the loyalty and affection of everyone he encounters in this classic story from Newbery Award–winning author Marguerite Henry.</b><br/><br/>Long ago, a lone little burro roamed the high cliffs of the Grand Canyon and touched the hearts of all who knew him: a grizzled old miner, a big-game hunter, even President Teddy Roosevelt. Named Brighty by the prospector who befriended him, he remained a free spirit at heart. But when a ruthless claim-jumper murdered the prospector, loyal Brighty risked everything to bring the killer to justice.<br/><br/>Brighty’s adventures have delighted generations of readers, and he has become the symbol of a joyous way of life. Some people say that you can even see his spirit roving the canyon on moonlit nights—forever wild, forever free.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marguerite Henry
      </h2>
      
      <p class="authorDescription body article">Marguerite Henry (1902&ndash;1997) was the beloved author of such classic horse stories as&#160;<I>King of the Wind</I>,&#160;<I>Misty of Chincoteague</I>,&#160;and&#160;<I>Stormy, Misty&rsquo;s Foal</I>, and her work has won several Newbery Awards and Honors.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35d85990